import axiosInstance from '@/utils/api.js'

var state = {
  dhcpv6: {
    arguments: {
      Dhcp6: {
        'server-id': {
          'enterprise-id': '',
          'htype': '',
          'identifier': '',
          'time': '',
          'type': '',
          'persist': false
        },
        'dhcp-queue-control': {
          'enable-queue': false,
          'queue-type': '',
          'capacity': ''
        },
        'expired-leases-processing': {
          'flush-reclaimed-timer-wait-time': '',
          'hold-reclaimed-time': '',
          'max-reclaim-leases': '',
          'max-reclaim-time': '',
          'reclaim-timer-wait-time': '',
          'unwarned-reclaim-cycles': ''
        },
        'interfaces-config': {
          're-detect': false
        },
        'subnet6': []
      }
    }
  },
  saveConfig: []
}

var getters = {
  DHCPV6: (state) => {
    return state.dhcpv6
  },
  SAVE_CONFIG: (state) => {
    return state.saveConfig
  }
}

var mutations = {
  SET_DHCPV6: (state, payload) => {
    state.dhcpv6 = payload
  },
  SET_SAVE_CONFIG: (state, payload) => {
    state.saveConfig = payload
  }
}

var actions = {
  GET_DHCPV6: async (context, payload) => {
    let result = await axiosInstance.get('/settings/dhcp6/config?loop_count_timeout=35')
    if (result.status === 200) {
      context.commit('SET_DHCPV6', result.data)
    }
  },
  SAVE_DHCPV6: (context, payload) => {
    return axiosInstance.put('/settings/dhcp6/set_config', payload)
  },
  SAVE_CONFIG_DHCPV6: async (context, payload) => {
    let result = await axiosInstance.get('/settings/dhcp6/config_write?loop_count_timeout=35')
    if (result.status === 200) {
      context.commit('SET_SAVE_CONFIG', result.data)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/settings/DHCPv6.js